import { render, staticRenderFns } from "./services_m.vue?vue&type=template&id=1f81aafb&scoped=true&"
import script from "./services_m.vue?vue&type=script&lang=js&"
export * from "./services_m.vue?vue&type=script&lang=js&"
import style0 from "./services_m.vue?vue&type=style&index=0&id=1f81aafb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f81aafb",
  null
  
)

export default component.exports